import React from "react";
import { Provider as StatusProvider } from "./context/StatusContext";
import { ThemeProvider } from "styled-components";
import { BrowserRouter as Router, Route } from "react-router-dom";
import { ListingRoutes } from "./routes";
import { StatusOverlay } from "./components";
import { useListingTheme } from "./hooks/";
import "./styles/Listing.scss";
const Listing = () => {
  const theme = useListingTheme();
  return (
    <ThemeProvider theme={theme}>
      <StatusProvider>
        <div id="Listing" className="App">
          <StatusOverlay />
          <Router>
            <Route
              exact
              path="/"
              component={() => {
                window.location.href = process.env.REACT_APP_API_URL;
                return null;
              }}
            />
            <Route path="/:slug" component={ListingRoutes} />
          </Router>
        </div>
      </StatusProvider>
    </ThemeProvider>
  );
};

export default Listing;
